import React from 'react';
import { motion } from 'framer-motion';
import { Door, Compass } from './graphics/Glyphs';
export function Leaders() {
  return <section id="leaders" className="bg-ink text-bone py-24 md:py-32 px-6 md:px-12" data-id="element-136">
      <div className="max-w-5xl mx-auto" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <p className="eyebrow !text-sun mb-6" data-id="element-139">The Hosts</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.1] text-bone" data-id="element-140">
            Not influencers. <br data-id="element-141" />
            <span className="italic text-sun" data-id="element-142">Women of influence.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-bone/15 border border-bone/15" data-id="element-143">
          {[{
          Glyph: Compass,
          kind: 'Local Leaders',
          line: 'Rooted in the destination.',
          body: 'Artists, makers, chefs, surf instructors, market guides.'
        }, {
          Glyph: Door,
          kind: 'Guest Leaders',
          line: 'Invited into the house.',
          body: 'Women invited to teach, host, and hold space for the group.'
        }].map((l, i) => {
          const Glyph = l.Glyph;
          return <motion.div key={l.kind} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: i * 0.1
          }} className="bg-ink p-10 md:p-14" data-id="element-144">
                <div className="w-10 h-10 mb-8 text-sun" data-id="element-145">
                  <Glyph className="w-full h-full" data-id="element-146" />
                </div>
                <p className="eyebrow !text-bone/50 mb-4" data-id="element-147">{l.kind}</p>
                <p className="font-serif-display italic text-bone text-2xl md:text-3xl mb-5 leading-snug" data-id="element-148">
                  {l.line}
                </p>
                <p className="text-bone/65 text-[14px] leading-[1.75] max-w-sm" data-id="element-149">
                  {l.body}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="mt-16 text-center font-serif-display italic text-bone/60 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-150">
          The kind of women you do not just follow. You learn from them.
        </motion.p>
      </div>
    </section>;
}